import React from 'react';
import EditButton from 'components/RestActions/EditButton';
import { useHistory } from 'react-router';
import { PERMISSION_KEY } from 'configs/localData';
import { ActionsStyles } from '../styles';

interface Props {
  id: string;
  packageName?: string;
  centreId?: string;
}

const GroupActionApplication = ({ id, packageName, centreId }: Props) => {
  const { push } = useHistory();

  const handleRedirect = () => {
    push(`/applications/${id}/show`);
  };
  return (
    <ActionsStyles>
      <EditButton
        permissionKey={PERMISSION_KEY.contacts}
        action="isView"
        packageName={packageName}
        isView
        onClickCustom={handleRedirect}
        centreId={centreId}
      />
    </ActionsStyles>
  );
};

export default GroupActionApplication;
